import React from 'react'
import { colors } from 'component-library/__styling/settings'

export interface Props {
    className?: string
    fill?: string
    width?: number
    height?: number
}

export const WeAreForAFLLogo: React.FC<Props> = props => {
    const fill = props.fill ? props.fill : colors.black

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 93 15"
            className={props.className}
            width={props.width}
            height={props.height}
        >
            <title>We're for AFL</title>
            <path
                fill={fill}
                fillRule="evenodd"
                d="M26.5,5.1L26.5,5.1l-0.1-0.9H24v7.7h2.5V6.6c0.4-0.2,1-0.3,1.7-0.3c0.2,0,0.5,0,0.6,0.1V4.1
	c-0.1,0-0.2-0.1-0.4-0.1C27.6,4.1,26.9,4.5,26.5,5.1z M11,1.8L9.6,8.1H9.5L8,1.8H5.7L4.1,8.1H4.1L2.8,1.8H0l2.4,10h2.8l1.5-6.2h0
	l1.5,6.2H11l2.4-10H11z M20.9,5h1.9l0.6-3.2H21L20.9,5z M17,4c-2.3,0-3.8,1.5-3.8,3.9v0.2c0,2.6,1.3,3.9,4,3.9
	c1.4,0,2.3-0.3,2.9-0.7V9.7c-0.6,0.2-1.4,0.5-2.3,0.5c-1.3,0-2-0.3-2.1-1.5h4.7V8C20.5,5.4,19.5,4,17,4z M15.7,7.2
	C15.9,6,16.4,5.7,17,5.7c0.7,0,1.1,0.4,1.1,1.5H15.7z M33.3,4c-2.3,0-3.8,1.5-3.8,3.9v0.2c0,2.6,1.3,3.9,4,3.9
	c1.4,0,2.3-0.3,2.9-0.7V9.7c-0.6,0.2-1.4,0.5-2.3,0.5c-1.3,0-2-0.3-2.1-1.5h4.7V8C36.8,5.4,35.9,4,33.3,4z M32.1,7.2
	c0.1-1.2,0.6-1.5,1.2-1.5c0.7,0,1.1,0.4,1.1,1.5H32.1z M84.8,1.6c0-0.4-0.6-0.6-1.4-0.6c-0.6,0-1.5,0.1-2.6,0.2
	c-2.4,0.2-5.7,0.6-7.6,0c-0.1,0-0.2,0-0.3,0c-0.2,0.1-0.3,0.5-0.3,0.8c0,0.6,2.7,0.9,2.9,0.9c0.9,0,2.1-0.1,3.4-0.3
	c2-0.2,4.1-0.5,5.3-0.2c0.1,0,0.2,0,0.3-0.1C84.6,2.1,84.8,1.8,84.8,1.6z M82.1,5.6c-1.4,0.4-3.3,0.6-5.2,0.7
	c0.2-0.4,0.3-0.8,0.5-1.2c0.3-0.7,0.4-1,0.4-1.2c0-0.4-0.3-0.6-0.8-0.7c-0.4,0-0.6,0.5-0.7,0.6c-0.2,0.6-0.6,1.6-0.9,2.4
	c-0.9,0-1.8-0.1-2.6-0.2c-0.1,0-0.3,0.1-0.4,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.5,2,0.6,2.9,0.7c-0.4,1.2-0.7,2.4-1,3.4
	c-0.4,1.2-0.7,2.2-0.7,2.3c-0.3,0.5-0.2,1-0.1,1.2c0.1,0.3,0.3,0.4,0.5,0.4c0.3,0,0.9-0.3,0.9-0.6c0,0,0-0.1,0-0.1
	c0-0.1,0-0.3,0-0.6c0.4-2.2,1.2-4.4,1.8-6c1.4-0.1,2.9-0.3,4.1-0.5c1-0.2,1.8-0.3,2.2-0.3c0.3,0,0.6-0.6,0.6-0.9
	c0-0.1,0-0.2-0.1-0.3C83,5.4,82.7,5.4,82.1,5.6z M69.7,7.9c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0.1-0.4,0.1-0.6,0.2
	c-0.2-1.8-0.3-3.4-0.3-4.5c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2c-0.1-1.8-0.2-3.4-1.3-3.5c-0.4,0-0.8,0-1,0.3
	c-0.2,0.3-0.2,0.8,0.1,1.5l0,0c-0.3,0.4-0.6,0.8-0.7,1.4c-1.3,1.8-2.4,3.5-3.8,5.6c-0.2-0.1-0.4-0.1-0.6-0.2l-0.1,0l-0.1,0
	C61,8.8,60.8,9,60.8,9.2c-0.1,0.3,0,0.6,0.3,1c-0.4,0.5-0.7,1.1-1.1,1.7c-0.3,0.5-0.6,1-0.9,1.5c-0.1,0.2-0.1,0.3,0,0.5
	c0.2,0.3,0.6,0.6,0.9,0.6h0c0.2,0,0.3-0.1,0.4-0.2c0.5-1.1,1.2-2.2,1.9-3.5c1.9,0.4,3.8-0.2,5.4-0.9c0.2,1.4,0.4,3,0.5,4.5
	c0,0.4,0.2,0.6,0.4,0.7c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.3-0.4,0.3-0.7c-0.4-1.3-0.8-2.9-1.1-4.8l0.1,0
	c0.5-0.2,1-0.4,1.4-0.5l0,0l0,0c0.1-0.2,0.1-0.4-0.1-0.6C70,7.9,69.8,7.9,69.7,7.9z M63.1,9.2c1.2-1.9,2.4-3.8,3.6-5.6l0,0l0.1,0.6
	c0.3,1.6,0.5,3,0.7,4.5C66,9.1,64.7,9.4,63.1,9.2z M92.7,12.3L92.7,12.3c-0.2-0.2-0.6-0.4-1-0.4c-0.2,0-0.7,0.2-1.4,0.4
	c-1,0.4-2.2,0.8-3,0.8c-1,0-1.6-1.1-1.6-2.9c0-2.3,2.3-7.7,3.1-8.7c0,0,0,0,0.1-0.1C88.8,1.4,89,1.3,89,1.2c0-0.4,0-0.7-0.2-0.9
	C88.6,0.1,88.4,0,88.2,0c-0.2,0-0.6,0.3-0.6,0.4c-0.2,0.9-0.7,2-1.2,3.1c-0.9,2.1-1.8,4.4-2,7c-0.1,0.9,0,2.1,0.8,2.9
	c0.5,0.6,1.2,0.8,2.2,0.8c0.8,0,2.3-0.5,3.5-0.9l0,0c0.2-0.1,0.9-0.3,1.1,0.2l0,0.1l0.1,0c0.3,0.1,0.7,0,0.9-0.3
	C93,13.1,93.1,12.6,92.7,12.3z M40,3.4v0.8h-1v1.8h1v5.9h2.5V5.9H44V4.1h-1.5V3.7c0-0.7,0.3-0.9,1-0.9c0.3,0,0.7,0,0.8,0.1V1.2
	C44.1,1.1,43.5,1,42.7,1C41.1,1,40,1.8,40,3.4z M48.4,4c-2.2,0-3.9,1.3-3.9,3.9v0.2c0,2.5,1.4,3.9,3.9,3.9c2.2,0,3.9-1.3,3.9-4V7.9
	C52.3,5.3,51,4,48.4,4z M49.7,8.2c0,1.6-0.5,2.1-1.3,2.1c-0.8,0-1.3-0.4-1.3-2.1V7.8c0-1.6,0.5-2.1,1.3-2.1c0.8,0,1.3,0.3,1.3,2.2
	V8.2z M55.7,5.1L55.7,5.1l-0.1-0.9h-2.4v7.7h2.5V6.6c0.4-0.2,1-0.3,1.7-0.3c0.2,0,0.5,0,0.6,0.1V4.1c-0.1,0-0.2-0.1-0.4-0.1
	C56.8,4.1,56.1,4.5,55.7,5.1z"
            />
        </svg>
    )
}
